export function onFirstClick(callback: () => void) {
    setTimeout(() => document.addEventListener('click', callback, {once: true}));
}
